export default __webpack_public_path__ + "static/Shop-dbaae53927a48d5301790f00cee707cc.jpg";